import { ColorEnum } from '@/constants/color'
import Notification from '@/features/notifications/components/Notification'
import ListItem from '@/features/notifications/components/NotificationCenter/parts/ListItem/Component'
import TitleAndBadge from '@/features/notifications/components/NotificationCenter/parts/ListItem/parts/TitleAndBadge'
import PotIcon from '@/features/notifications/components/icons/PotIcon'
import { FC } from 'react'

interface PostponedOrderProps {
    heading: string
    createdAt: number
    title: string
    orderShortCode: string
    description?: string
    read: boolean
    onPress: () => void
}

const PostponedOrder: FC<PostponedOrderProps> = ({
    heading,
    createdAt,
    title,
    orderShortCode,
    description,
    read,
    onPress,
}) => {
    return (
        <ListItem
            Icon={PotIcon}
            iconContainerColor={ColorEnum.EMERALD_200}
            heading={heading}
            createdAt={createdAt}
            Title={<TitleAndBadge title={title} badge={orderShortCode} />}
            Description={
                description && <Notification.Description>{description}</Notification.Description>
            }
            read={read}
            onPress={onPress}
        />
    )
}

export default PostponedOrder
